import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    tabs: {
      description: 'Determinates header titles and icons',
      required: true,
      type: Array,
    },
    tabsPositionValue: {
      default: 'static',
      description:
        'Value for the tabs position css property (sticky, static, etc)',
      type: String,
    },
    useSlots: {
      default: false,
      description: 'Adds slots to provide change tab logic out of the box',
      type: Boolean,
    },
    startingTab: {
      default: 0,
      description: 'Index of tab selected when the component is created',
      type: Number,
    },
    marginLeft: {
      default: '0px',
      description: 'Can be used to set negative margin and fit 100vw',
      type: String,
    },
    marginRight: {
      default: '0px',
      description: 'Can be used to set negative margin and fit 100vw',
      type: String,
    },
    tabGrow: {
      default: false,
      description: 'tab will grow to fit 100% of the space',
      type: Boolean,
    },
    categoryFriendsDay: {
      default: false,
      type: Boolean,
    },
    isReservationBuy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
})
export default class SelectionMenuTabsComponent extends Vue {
  currentTab = this.startingTab;

  mounted() {
    this.setIndicatorStyle();
  }

  /*
   * Do the change tab animation and emit 'tabSelected' event if slots aren't used.
   * See slite front components docs for further details
   */
  changeTab(position) {
    this.currentTab = position;

    const { tabList } = this.$refs;
    const tabSelected = tabList?.children[this.currentTab];
    const tabSelectedX = tabSelected.getBoundingClientRect().x;
    tabList.scrollLeft +=
      tabSelectedX - (window.innerWidth - tabSelected.offsetWidth) / 2;

    this.setIndicatorStyle();
    if (!this.useSlots) {
      this.$emit('tabSelected', this.currentTab);
    }
  }

  get indicatorPosition() {
    return this.$refs.tabList?.children[this.currentTab].offsetLeft;
  }

  get indicatorWidth() {
    return this.$refs.tabList?.children[this.currentTab].clientWidth;
  }

  get indicatorStyles() {
    return {
      left: `${this.indicatorPosition}px`,
      width: `${this.indicatorWidth}px`,
    };
  }

  setIndicatorStyle() {
    if (this.$refs.indicator) {
      this.$refs.indicator.style.left = this.indicatorStyles.left;
      this.$refs.indicator.style.width = this.indicatorStyles.width;
    }
  }

  get withoutImage() {
    return this.tabs instanceof Array;
  }
}
